import {
  FaHtml5,
  FaCss3Alt,
  FaJs,
  FaReact,
  FaVuejs,
  FaAngular,
  FaNodeJs,
  FaSass,
  FaDocker,
  FaAws,
  FaJava,
  FaGitAlt,
  FaRegFilePdf,
  FaFigma,
} from "react-icons/fa";
import {
  SiMongodb,
  SiExpress,
  SiWebpack,
  SiTypescript,
  SiSpring,
  SiPostgresql,
  SiHeroku,
  SiNetlify,
  SiRuby,
  SiRubyonrails,
  SiPython,
  SiNewrelic,
  SiMysql,
  SiOracle,
  SiLaravel,
  SiSonarqube,
  SiKotlin,
  SiPhp,
  SiVisualbasic,
  SiVisualstudio,
  SiVisualstudiocode,
  SiRubymine,
  SiEclipseide,
  SiIntellijidea,
  SiGithub,
  SiGitlab,
  SiBitbucket,
  SiCircleci,
  SiJira,
  SiTrello,
  SiElasticsearch,
  SiMagento,
  SiRedis,
  SiGnubash,
  SiFlask,
  SiFastapi,
  SiDjango,
  SiFirebase,
  SiJest,
  SiMicrosoftsqlserver,
  SiSqlite,
  SiMariadb,
  SiPostman,
  SiGrafana,
  SiUipath,
  SiRabbitmq,
  SiSelenium,
  SiApachekafka,
  SiShopify,
  SiNextdotjs,
  SiNestjs,
  SiVercel,
  SiStyledcomponents,
  SiStorybook,
  SiApachetomcat,
  SiApachenetbeanside,
} from "react-icons/si";
import { RiAngularjsFill } from "react-icons/ri";
import { GiGears } from "react-icons/gi";
import { DiScrum, DiAndroid, DiNginx } from "react-icons/di";
import { TbSql } from "react-icons/tb";
import { BiBrain, BiConversation } from "react-icons/bi";
import { MdOutlineGroupWork, MdOutlineAccountTree } from "react-icons/md";

export const skillLevels = {
  basico: {
    description: "Conozco los conceptos fundamentales, he realizado proyectos simples, configuraciones sencillas y en algunos casos, aprendiendo de algunas de estas tecnologías.",
    skills: [
      { name: "Figma", icon: <FaFigma className="text-2xl" /> },
      { name: "Grafana", icon: <SiGrafana className="text-2xl" /> },
      { name: "Visual Basic", icon: <SiVisualbasic className="text-2xl" /> },
      { name: "Vue", icon: <FaVuejs className="text-2xl" /> },
      { name: "Django", icon: <SiDjango className="text-2xl" /> },
      { name: "UIpath", icon: <SiUipath className="text-2xl" /> },
      { name: "RabbitMQ", icon: <SiRabbitmq className="text-2xl" /> },
      { name: "Selenium", icon: <SiSelenium className="text-2xl" /> },
      { name: "Sass", icon: <FaSass className="text-2xl" /> },
      { name: "Webpack", icon: <SiWebpack className="text-2xl" /> },
      { name: "Heroku", icon: <SiHeroku className="text-2xl" /> },
      { name: "Netlify", icon: <SiNetlify className="text-2xl" /> },
      { name: "New Relic", icon: <SiNewrelic className="text-2xl" /> },
      { name: "SonarQube", icon: <SiSonarqube className="text-2xl" /> },
      { name: "Visual Studio", icon: <SiVisualstudio className="text-2xl" /> },
      { name: "Eclipse IDE", icon: <SiEclipseide className="text-2xl" /> },
      { name: "CircleCI", icon: <SiCircleci className="text-2xl" /> },
      { name: "Elasticsearch", icon: <SiElasticsearch className="text-2xl" /> },
      { name: "Redis", icon: <SiRedis className="text-2xl" /> },
      { name: "AngularJS", icon: <RiAngularjsFill className="text-2xl" /> },
      { name: "Android", icon: <DiAndroid className="text-2xl" /> },
      { name: "Tomcat", icon: <SiApachetomcat className="text-2xl" /> },
      { name: "Netbeans", icon: <SiApachenetbeanside className="text-2xl" /> },
      { name: "Nginx", icon: <DiNginx className="text-2xl" /> },
      { name: "Magento", icon: <SiMagento className="text-2xl" /> },
    ]
  },
  intermedio: {
    description: "Tengo experiencia y puedo trabajar de forma independiente en proyectos de mediana complejidad y un poco más. Así como ser capaz de enseñar a otros.",
    skills: [
      { name: "AWS", icon: <FaAws className="text-2xl" /> },
      { name: "Kotlin", icon: <SiKotlin className="text-2xl" /> },
      { name: "Firebase", icon: <SiFirebase className="text-2xl" /> },
      { name: "Kafka", icon: <SiApachekafka className="text-2xl" /> },
      { name: "Jest", icon: <SiJest className="text-2xl" /> },
      { name: "Shopify", icon: <SiShopify className="text-2xl" /> },
      { name: "Next.js", icon: <SiNextdotjs className="text-2xl" /> },
      { name: "NestJS", icon: <SiNestjs className="text-2xl" /> },
      { name: "Vercel", icon: <SiVercel className="text-2xl" /> },
      { name: "Styled Components", icon: <SiStyledcomponents className="text-2xl" /> },
      { name: "Storybook", icon: <SiStorybook className="text-2xl" /> },
      {
        name: "SQLServer",
        icon: <SiMicrosoftsqlserver className="text-2xl" />,
      },
      { name: "Spring", icon: <SiSpring className="text-2xl" /> },
      { name: "PHP", icon: <SiPhp className="text-2xl" /> },
      { name: "Python", icon: <SiPython className="text-2xl" /> },
      { name: "Flask", icon: <SiFlask className="text-2xl" /> },
      { name: "FastAPI", icon: <SiFastapi className="text-2xl" /> },
      { name: "Laravel", icon: <SiLaravel className="text-2xl" /> },
      { name: "Angular", icon: <FaAngular className="text-2xl" /> },
      { name: "Docker", icon: <FaDocker className="text-2xl" /> },
      { name: "MongoDB", icon: <SiMongodb className="text-2xl" /> },
      { name: "Express", icon: <SiExpress className="text-2xl" /> },
      { name: "CSS", icon: <FaCss3Alt className="text-2xl" /> },
      { name: "PostgreSQL", icon: <SiPostgresql className="text-2xl" /> },
      { name: "Oracle", icon: <SiOracle className="text-2xl" /> },
      { name: "SQLite", icon: <SiSqlite className="text-2xl" /> },
      { name: "SQL", icon: <TbSql className="text-2xl" /> },
      { name: "MariaDB", icon: <SiMariadb className="text-2xl" /> },
      { name: "GitHub", icon: <SiGithub className="text-2xl" /> },
      { name: "GitLab", icon: <SiGitlab className="text-2xl" /> },
      { name: "Bitbucket", icon: <SiBitbucket className="text-2xl" /> },
      { name: "IntelliJ IDEA", icon: <SiIntellijidea className="text-2xl" /> },
      { name: "RubyMine", icon: <SiRubymine className="text-2xl" /> },
      { name: "GNU Bash", icon: <SiGnubash className="text-2xl" /> },
    ]
  },
  avanzado: {
    description: "Tengo mucha experiencia y conocimiento de la tecnología, puedo resolver problemas complejos y soy capaz de enseñar a otros.",
    skills: [
      { name: "React", icon: <FaReact className="text-2xl" /> },
      { name: "JavaScript", icon: <FaJs className="text-2xl" /> },
      { name: "TypeScript", icon: <SiTypescript className="text-2xl" /> },
      { name: "Git", icon: <FaGitAlt className="text-2xl" /> },
      { name: "Ruby", icon: <SiRuby className="text-2xl" /> },
      { name: "Ruby on Rails", icon: <SiRubyonrails className="text-2xl" /> },
      { name: "HTML", icon: <FaHtml5 className="text-2xl" /> },
      { name: "JasperReports", icon: <FaRegFilePdf className="text-2xl" /> },
      { name: "Java", icon: <FaJava className="text-2xl" /> },
      { name: "Node.js", icon: <FaNodeJs className="text-2xl" /> },
      { name: "MySQL", icon: <SiMysql className="text-2xl" /> },
      { name: "Postman", icon: <SiPostman className="text-2xl" /> },
      {
        name: "Visual Studio Code",
        icon: <SiVisualstudiocode className="text-2xl" />,
      },
      { name: "Jira", icon: <SiJira className="text-2xl" /> },
      { name: "Trello", icon: <SiTrello className="text-2xl" /> },
      { name: "Scrum", icon: <DiScrum className="text-2xl" /> },
    ]
  },
};

export const softSkills = [
  {
    name: "Trabajo en equipo",
    icon: <MdOutlineGroupWork className="text-2xl" />,
  },
  {
    name: "Comunicación efectiva",
    icon: <BiConversation className="text-2xl" />,
  },
  {
    name: "Resolución de problemas",
    icon: <MdOutlineAccountTree className="text-2xl" />,
  },
  { name: "Adaptabilidad", icon: <GiGears className="text-2xl" /> },
  { name: "Aprendizaje continuo", icon: <BiBrain className="text-2xl" /> },
];
